const carrierTypes = {
	amazon: 'Amazon Shipping',
	ups: 'UPS',
	fedex: 'FedEx',
	usps: 'USPS',
	passport: 'Passport',
	ltl: 'LTL',
};

export { carrierTypes };



// WEBPACK FOOTER //
// ./src/common/constants/carrierTypes.js